import { useSelector } from "react-redux";
import "./Modal.css";

interface ModalProps {
  children: any;
  extraChildren?: any;
  title: string;
  size: string;
  onClose: () => void;
}

export const Modal = ({
  children,
  onClose,
  size,
  title,
  extraChildren,
}: ModalProps) => {
  let showheader = useSelector((state: any) => state.modalComponents.value);

  return (
    <div className="modal-overlay">
      <div className="modal-container" style={{ width: size }}>
        {showheader && (
          <>
            <div className="modal-header">
              <div className="modal-title">
                <h1>{title}</h1>
                <button onClick={onClose} className="close-button">
                  &times;
                </button>
              </div>
              {extraChildren}
            </div>
          </>
        )}

        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
};
